import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { authRoutes, privateRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import NotFound from "../NotFound";

const ALLRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/dashboard" element={<Navigate to="/index" replace />} />
      {/* <Route path="/" element={<Navigate to="/index" replace />} /> */}

      {/* Public Auth Routes */}
      <Route element={<AuthFeature />}>
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <PublicRoute>
                {route.element}
              </PublicRoute>
            }
          />
        ))}
      </Route>

      {/* Private Routes */}
      <Route element={<Feature />}>
        {privateRoutes.map((route, idx) => (
          <Route
            path={route.path}
            key={idx}
            element={
              <PrivateRoute allowedRoles={route.allowedRoles}>
                {route.element}
              </PrivateRoute>
            }
          />
        ))}
      </Route>
      {/* {404 path for all other unauthorized paths} */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default ALLRoutes;
